import { useEffect, useState } from "react";

export default function CustomCursor() {
    const [pos, setPos] = useState({ x: -100, y: -100 });
    const [dotPos, setDotPos] = useState({ x: -100, y: -100 });
    const [hover, setHover] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;
        if (window.matchMedia("(hover: none)").matches) return;

        let raf;
        let mouseX = -100;
        let mouseY = -100;
        let ringX = -100;
        let ringY = -100;

        const onMove = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            setDotPos({ x: mouseX, y: mouseY });
            setVisible(true);

            const t = e.target;
            const isInteractive =
                t.closest("a, button, input, textarea, select, [data-cursor='hover']");
            setHover(!!isInteractive);
        };

        const onLeave = () => setVisible(false);

        const animate = () => {
            ringX += (mouseX - ringX) * 0.18;
            ringY += (mouseY - ringY) * 0.18;
            setPos({ x: ringX, y: ringY });
            raf = requestAnimationFrame(animate);
        };

        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseleave", onLeave);
        animate();

        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseleave", onLeave);
            cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <>
            <div
                className={`custom-cursor ${hover ? "cursor-hover" : ""}`}
                style={{
                    transform: `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)`,
                    opacity: visible ? 1 : 0,
                }}
            />
            <div
                className="custom-cursor-dot"
                style={{
                    transform: `translate(${dotPos.x}px, ${dotPos.y}px) translate(-50%, -50%)`,
                    opacity: visible && !hover ? 1 : 0,
                }}
            />
        </>
    );
}
